module.exports = __webpack_public_path__ + "static/media/serch.fd2358a0.svg";